module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-cangzhou.ed863a04.png";